<div class="vessels-container">

  <div class="vessels-sticky-header">
    <div class="tabs-inner-wrapper">
      <div class="sub-tabs" [appTourAnchor]="'vessel.sectionTabs'">
        <button class="sub-tab" [class.active]="activeTab === 'my-vessel'" (click)="switchTab('my-vessel')">
          My Vessels
        </button>
        <button class="sub-tab" [appTourAnchor]="'vessel.requestsTab'"
          [class.active]="activeTab === 'requests'" (click)="switchTab('requests')">
          Requests
          <span class="badge" *ngIf="incomingRequestsCount > 0">{{ formatBadgeCount(incomingRequestsCount) }}</span>
        </button>
        <button class="sub-tab" [appTourAnchor]="'vessel.sentRequestsTab'"
          [class.active]="activeTab === 'sent-requests'" (click)="switchTab('sent-requests')">
          Sent Requests
        </button>
      </div>
    </div>
  </div>

  <div class="vessels-content-wrapper">

    <div *ngIf="loading && activeTab === 'my-vessel' && vessels.length > 0" class="loader-overlay">
      <div class="round-loader"></div>
    </div>

  <!-- ══ TAB 1: MY VESSEL (read-only) ══ -->
  <ng-container *ngIf="activeTab === 'my-vessel'">

    <div class="vessel-skeleton" *ngIf="loading && vessels.length === 0">
      <div class="skeleton-card">
        <div class="skeleton-line medium skeleton-snap-title"></div>
        <div class="skeleton-rect skeleton-vessel-image"></div>
        <div class="skeleton-snap-grid">
          <div class="skeleton-rect skeleton-snap-cell" *ngFor="let i of [1,2,3,4,5,6]"></div>
        </div>
      </div>
    </div>

    <div class="vessels-content" *ngIf="vessels.length > 0 && selectedVessel">
      <div class="vessel-card">

        <!-- Header: vessel switcher -->
        <div class="vessel-card-header">
          <div class="vessel-dropdown" [appTourAnchor]="'vessel.switchDropdown'"
            (click)="toggleVesselDropdown($event)">
            <mat-icon class="vessel-lock-icon" *ngIf="selectedVessel?.is_borrowed">lock</mat-icon>
            <span class="vessel-dropdown-name">{{ selectedVessel?.name || 'Select Vessel' }}</span>
            <mat-icon class="dropdown-chevron" [class.open]="showVesselDropdown">expand_more</mat-icon>

            <div class="vessel-dropdown-menu" *ngIf="showVesselDropdown" (click)="$event.stopPropagation()">
              <div class="vessel-dropdown-item" *ngFor="let v of vessels"
                [class.selected]="selectedVessel?._id === v._id" (click)="selectVessel(v)">
                <span class="dropdown-item-name">{{ v.name }}</span>
                <mat-icon *ngIf="selectedVessel?._id === v._id" class="dropdown-check">check</mat-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- Hero photo -->
        <div class="hero">
          <div class="hero-scroller" #imageScroller (scroll)="onImageScroll(imageScroller)">
            <div class="hero-item" *ngFor="let img of selectedVessel.images">
              <img [src]="img.image_url || 'assets/home/profile/banner_vessel.webp'" class="hero-img" alt="" loading="lazy" decoding="async" />
            </div>
            <div class="hero-item" *ngIf="!selectedVessel.images?.length">
              <img src="assets/home/profile/banner_vessel.webp" class="hero-img" alt="" />
            </div>
          </div>
          <div class="hero-dots" *ngIf="selectedVessel.images?.length > 1">
            <span *ngFor="let img of selectedVessel.images; let i = index" class="dot"
              [class.active]="i === currentImageIndex"></span>
          </div>
          <div class="hero-lock" *ngIf="isVesselLentOut">
            <mat-icon>lock</mat-icon>
            <span *ngIf="borrowerDisplayName">{{ borrowerDisplayName }}</span>
          </div>
        </div>

        <!-- Status (read-only badges) -->
        <div class="status-row">
          <div class="status-badge in-use" *ngIf="isVesselLentOut">
            <mat-icon>warning_amber</mat-icon>
            <span>In use by {{ borrowerDisplayName || 'a user' }}</span>
          </div>
          <div class="status-badge borrowed" *ngIf="isVesselBorrowed && !isVesselLentOut">
            <mat-icon>lock</mat-icon><span>Borrowed</span>
          </div>
          <div class="status-badge" [class.primary]="selectedVessel.is_primary"
            [appTourAnchor]="'vessel.primaryToggle'">
            <mat-icon>anchor</mat-icon>
            <span>{{ selectedVessel.is_primary ? 'Primary vessel' : 'Not primary' }}</span>
          </div>
        </div>

        <!-- Specs -->
        <div class="specs" [appTourAnchor]="'vessel.information'">
          <div class="spec">
            <span class="spec-value">{{ selectedVessel.details?.manufacturer || '—' }}</span>
            <span class="spec-label">Make</span>
          </div>
          <div class="spec">
            <span class="spec-value">
              {{ selectedVessel.specifications?.length_overall?.value || '0.0' }}
              <small>{{ selectedVessel.specifications?.length_overall?.unit === 'meters' ? 'm' : 'ft' }}</small>
            </span>
            <span class="spec-label">LOA</span>
          </div>
          <div class="spec">
            <span class="spec-value">
              {{ selectedVessel.specifications?.draft?.value || '0.0' }}
              <small>{{ selectedVessel.specifications?.draft?.unit === 'meters' ? 'm' : 'ft' }}</small>
            </span>
            <span class="spec-label">Draft</span>
          </div>
          <div class="spec">
            <span class="spec-value">{{ selectedVessel.details?.hull_color || 'Other' | titlecase }}</span>
            <span class="spec-label">Hull color</span>
          </div>
        </div>

        <div class="reg-line" *ngIf="selectedVessel.details?.registration?.MMSI">
          MMSI <span>{{ selectedVessel.details.registration.MMSI }}</span>
        </div>
        <div class="reg-line" *ngIf="selectedVessel.details?.registration?.commercial_number">
          Vessel ID <span>{{ selectedVessel.details.registration.commercial_number }}</span>
        </div>

        <!-- Information (live telemetry, like the mobile card) -->
        <h3 class="section-title" [appTourAnchor]="'vessel.snapshot'">Information</h3>

        <div class="tiles" *ngIf="snapshotLoading">
          <div class="skeleton-rect tile-skeleton" *ngFor="let i of [1,2,3,4,5,6]"></div>
          <div class="skeleton-rect tile-skeleton full"></div>
        </div>

        <div class="snapshot-unavailable" *ngIf="!snapshotLoading && !snapshotAvailable">
          <img src="assets/common_icons/vessel_nointernet.svg" alt="" />
          <span>Latest snapshot unavailable</span>
        </div>

        <div class="tiles" *ngIf="!snapshotLoading && snapshotAvailable && snapshot">
          <div class="tile">
            <div class="tile-value">{{ snapshot.sogValue }}<span class="unit"> {{ snapshot.sogUnit }}</span></div>
            <div class="tile-label">SOG</div>
          </div>
          <div class="tile">
            <div class="tile-value">{{ snapshot.cogDeg }}<span class="unit">°</span></div>
            <div class="tile-label">COG</div>
          </div>
          <div class="tile">
            <div class="tile-value">{{ snapshot.waterTempValue }}<span class="unit">{{ snapshot.waterTempUnit }}</span></div>
            <div class="tile-label">Water Temp</div>
          </div>
          <div class="tile">
            <div class="tile-value">{{ snapshot.waterDepthValue }}<span class="unit"> {{ snapshot.waterDepthUnit }}</span></div>
            <div class="tile-label">Water Depth</div>
          </div>
          <div class="tile">
            <div class="tile-value">{{ snapshot.batteryV }}<span class="unit"> V</span></div>
            <div class="tile-label">Battery</div>
          </div>
          <div class="tile">
            <div class="tile-value">{{ snapshot.lastUpdated }}</div>
            <div class="tile-label">Last Updated</div>
          </div>
          <div class="tile full">
            <div class="tile-value">{{ snapshot.coordsDisplay }}</div>
            <div class="tile-label">Current Position</div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-data" *ngIf="!loading && vessels.length === 0">
      <p>No vessels added yet</p>
    </div>
  </ng-container>

  <!-- ══ TAB 2: INCOMING REQUESTS (read-only) ══ -->
  <ng-container *ngIf="activeTab === 'requests'">
    <div class="requests-content" [appTourAnchor]="'vessel.requestsList'">
      <div class="request-skeleton" *ngIf="loading">
        <div class="skeleton-card skeleton-request-card" *ngFor="let i of [1,2,3]">
          <div class="skeleton-header">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-text-group">
              <div class="skeleton-line short"></div>
              <div class="skeleton-line x-short"></div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!loading">
        <div *ngIf="incomingRequests.length === 0" class="empty-tab-state">
          <mat-icon class="empty-icon">inbox</mat-icon>
          <p>No pending borrow requests</p>
        </div>

        <div class="request-card" *ngFor="let req of incomingRequests">
          <img class="request-avatar"
            [src]="req.requester_ref_doc?.image_url || 'assets/common_icons/vessel_image.svg'"
            (error)="$any($event.target).src='assets/common_icons/vessel_image.svg'" alt="" />
          <div class="request-details">
            <div class="request-name">{{ getDisplayName(req.requester_ref_doc) }}</div>
            <div class="request-vessel-name">
              <mat-icon class="anchor-sm">anchor</mat-icon>{{ req.vessel_ref?.name }}
            </div>
          </div>
          <div class="request-meta">
            <span class="request-status" [class.waitlisted]="isWaitlisted(req)">{{ requestStatusLabel(req) }}</span>
            <span class="request-time">{{ timeAgo(req.requested_at) }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- ══ TAB 3: SENT REQUESTS (read-only) ══ -->
  <ng-container *ngIf="activeTab === 'sent-requests'">
    <div class="requests-content" [appTourAnchor]="'vessel.sentRequestsList'">
      <div class="request-skeleton" *ngIf="loading">
        <div class="skeleton-card skeleton-request-card" *ngFor="let i of [1,2,3]">
          <div class="skeleton-header">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-text-group">
              <div class="skeleton-line short"></div>
              <div class="skeleton-line x-short"></div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!loading">
        <div *ngIf="sentRequests.length === 0" class="empty-tab-state">
          <mat-icon class="empty-icon">send</mat-icon>
          <p>No sent borrow requests</p>
        </div>

        <div class="request-card" *ngFor="let req of sentRequests">
          <img class="request-avatar" [src]="req.owner_ref_doc?.image_url || 'assets/common_icons/vessel_image.svg'"
            (error)="$any($event.target).src='assets/common_icons/vessel_image.svg'" alt="" />
          <div class="request-details">
            <div class="request-name">{{ getDisplayName(req.owner_ref_doc) }}</div>
            <div class="request-vessel-name">
              <mat-icon class="anchor-sm">anchor</mat-icon>{{ req.vessel_ref?.name }}
            </div>
          </div>
          <div class="request-meta">
            <span class="request-status" [class.waitlisted]="isWaitlisted(req)"
              [class.ended]="isForceEnded(req)" [class.returned]="isReturned(req)">{{ requestStatusLabel(req) }}</span>
            <span class="request-time">{{ timeAgo(req.requested_at) }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  </div>
</div>
